// extracted by mini-css-extract-plugin
export default {"semeia-chat":"_semeia-chat_-xd0LR"};